import r from "./index915.js";
import m from "./index916.js";
import h from "./index917.js";
import l from "./index918.js";
import c from "./index919.js";
function e(t) {
  var o = -1, a = t == null ? 0 : t.length;
  for (this.clear(); ++o < a; ) {
    var p = t[o];
    this.set(p[0], p[1]);
  }
}
e.prototype.clear = r;
e.prototype.delete = m;
e.prototype.get = h;
e.prototype.has = l;
e.prototype.set = c;
export {
  e as default
};
